import { render, staticRenderFns } from "./_purchasesReturns.vue?vue&type=template&id=05708d70&scoped=true&"
import script from "./_purchasesReturns.vue?vue&type=script&lang=js&"
export * from "./_purchasesReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05708d70",
  null
  
)

export default component.exports